import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
// import {getToken} from '@/utils/auth';
// import router, { resetRouter } from '@/router'
// console.log('base api url', process.env.VUE_APP_BASE_API);
// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        // console.log('req info', store.getters.userinfo);
        if (store.getters.userinfo && store.getters.userinfo.token) {
            config.headers['Authorization'] = `Bearer ${store.getters.userinfo.token}`;
        }
        // console.log('config', config);
        return config
    },
    error => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error)
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data;
        console.log('[response]', response.config.method, response.config.url, res);
        // if the custom code is not 20000, it is judged as an error.
        if (res.code !== 0) {
            const errorMsg = {
                "-4": "无访问权限"
            };
            console.log('[error message]', errorMsg[res.code] || res.msg || 'Error');
            Message({
                message: errorMsg[res.code] || res.msg || 'Error',
                type: 'error',
                duration: 5 * 1000
            });
            if(res.code === -1) {
                console.log('store', store);
                store.dispatch("user/logout", {}).then(() => {
                   console.log("token fail clear success");
                });
            }
            return Promise.reject(errorMsg[res.code] || res.msg || 'Error');
        } else {
            return res;
        }
    },
    error => {
        console.log('err', error); // for debug
        console.log('err code', error.code);
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.reject(error);
    }
);

export default service
